export default "__VITE_ASSET__5c997299__"